import {forwardRef, Ref, useImperativeHandle, useState} from 'react';

import './Button.scss';
import {useTypedSelector} from "../../hooks/useTypeSelector";
import {UserDto} from "../../dtos";

export interface IButtonRef {
    showOn: (value: boolean) => void
}

interface IButton {
    svg?: React.FunctionComponent<React.SVGProps<SVGSVGElement> & { title?: string }>;
    colorOn: string;
    colorOff: string;
    text: string;
    onClick: (isOn: boolean) => void;
    isToggle?: boolean;
}

export const ButtonForFramesTopBar = forwardRef((props: IButton, ref: Ref<IButtonRef>) => {

    useImperativeHandle(ref, () => ({showOn}));
    let flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    let userDtoStr = localStorage.getItem('userDto');
    // const isUserViewer = false;
    let isUserViewer = true;
    if(userDtoStr){
        let userDto: UserDto = JSON.parse(userDtoStr);
        isUserViewer = userDto.role !== 2 && userDto.role !== 3;
    }



    const [isOn, setIsOn] = useState(false);

    let imageClass = '';
    let imageFill = ''

    let textClass = '';
    let textColor = ''

    if (isOn) {
        imageClass = 'imageSelected';
        textClass = 'textSelected';

        imageFill = `${props.colorOn}`
        textColor = `${props.colorOn}`

    } else {
        imageClass = 'imageUnSelected';
        textClass = 'textUnSelected';

        imageFill = `${props.colorOff}`
        textColor = `${props.colorOff}`
    }

    let SVGICon = props.svg ? props.svg! : null

    const handleOnClick = () => {

        if (props.isToggle) {
            setIsOn((currentState: boolean) => {

                let nextState = !currentState
                props.onClick(nextState);

                return nextState
            });
        }
    }

    const handleMouseDown = () => {
        if (!props.isToggle) {
            setIsOn(true);
        }
    }

    const handleMouseUp = () => {
        if (!props.isToggle) {
            setIsOn(false);
            props.onClick(true);
        }
    }

    const showOn = (value: boolean) => {
        setIsOn(value)
        props.onClick(value);
    }

    return (
        <div
            style={{cursor: "pointer"}}
            className={`${flyerDetailsState.flyFstRec.fstCaption === "Published" || isUserViewer ? 'disabled' : ''} two_states_button`}
            onClick={handleOnClick}
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
        >
            {SVGICon &&
                <SVGICon
                    className={`${imageClass} ${props.text === 'Auto-Number' ? 'framesOrientation' : ''}`}
                    // style={{fill: imageFill}}
                />
            }

            <span
                className={textClass}
                style={{color: textColor}}
            >
        {props.text}
      </span>
        </div>
    );
});
